import Vue from 'vue'
// 使用 require 替代 import
const VueRouter = require('vue-router').default

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash',
  // 核心配置：跳转后滚动到顶部
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('../views/Home.vue')
    },
    {
      path: '/news',
      name: 'News',
      component: () => import('../views/News.vue')
    },
    {
      path: '/cases',
      name: 'Cases',
      component: () => import('../views/Cases.vue')
    },
    {
      path: '/about',
      name: 'About',
      component: () => import('../views/About.vue')
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: () => import('../views/PrivacyPolicy.vue')
    },
    {
      path: '/city-info/:sign',
      name: 'CityInfo',
      component: () => import('../views/CityInfo.vue')
    },
    {
      path: '/disclaimer',
      name: 'Disclaimer',
      component: () => import('../views/Disclaimer.vue')
    },
    {
      path: '/services',
      name: 'Services',
      component: () => import('../views/Services.vue')
    },
    {
      path: '/services/:id',
      name: 'ServiceDetail',
      component: () => import('../views/ServiceDetail.vue'),
      props: true
    },
    {
      path: '/contact',
      name: 'Contact',
      component: () => import('../views/Contact.vue')
    },
    {
      path: '/roadshow',
      name: 'Roadshow',
      component: () => import('../views/Roadshow.vue')
    },
    {
      path: '/forum',
      name: 'Forum',
      component: () => import('../views/Forum.vue')
    },
    {
      path: '/training',
      name: 'Training',
      component: () => import('../views/Training.vue')
    },
    {
      path: '/exhibitions',
      name: 'Exhibitions',
      component: () => import('../views/Exhibitions.vue')
    },
    {
      path: '/oneonone',
      name: 'OneOnOne',
      component: () => import('../views/OneOnOneService.vue')
    },
    {
      path: '/temp',
      name: 'Temp',
      component: () => import('../views/Temp.vue')
    },
    {
      path: '/destination',
      name: 'Destination',
      meta: { showHeader: false, showFooter: false },
      component: () => import('../views/Destination.vue')
    },
    {
      path: '/products',
      name: 'Products',
      component: () => import('../views/Products.vue')
    },
    {
      path: '/product/:id',
      name: 'ProductDetail',
      component: () => import('../views/ProductDetail.vue'),
      props: true
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

// 百度统计：单页应用（hash 模式）路由切换时上报页面浏览
router.afterEach((to) => {
  if (window._hmt) {
    window._hmt.push(['_trackPageview', '/#' + (to.fullPath || '/')])
  }
})

export default router